import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthServerProvider, IUser, UpdateUser } from 'app/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { faEyeSlash, faEye, faPenSquare } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { CURRENTPOLICYVERSION, PHONE_ACQUISITION_ENABLED, PHONE_VALIDATION_ENABLED, SERVER_API_URL } from 'app/app.constants';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { DataSharingService } from 'app/layouts/homepage/services/data-sharing.service';
import { TranslateService } from '@ngx-translate/core';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'jhi-edit-account-info',
    templateUrl: './edit-account-info.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class EditAccountInfoComponent implements OnInit, OnDestroy {
    user: IUser;
    userForm: FormGroup;
    submitted = false;
    faCheckCircle = faCheckCircle;
    faExclamationCircle = faExclamationCircle;
    faEyeSlash = faEyeSlash;
    faEye = faEye;
    faPenSquare = faPenSquare;
    verifiedPhone = false;
    verifiedEmail = false;
    verifiedAltEmail = false;
    appUrl = '';
    successMsg: string;
    errorMsg = '';
    enableConfirm: boolean;
    privacyPolicyVersion = CURRENTPOLICYVERSION;
    privacyPolicyUpToDate: boolean;
    private subscriptions: Subscription[] = [];
    showPrivacyPolicy = false;
    prefixes: number[];
    isAnswerSetted: boolean;
    privacyPolicyHtml: string;
    isFirstLogin: boolean;
    loading: boolean;
    phoneAcquisitionEnabled: boolean = PHONE_ACQUISITION_ENABLED;
    phoneValidationEnabled: boolean = PHONE_VALIDATION_ENABLED && PHONE_ACQUISITION_ENABLED;
    isMefMail: boolean;
    errorAlternativeEmail: Error;
    errorEmail: Error;
    errorPhone: Error;
    showPin = false;
    organization: string;
    orgDag: boolean;
    canAccessForm: boolean = false;  // Controls if user can access the form
    pwdlessWarningMessage: string = null;  // Warning message for non-EXTRA_UE users

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private userService: UserService,
        private router: Router,
        private jwtService: AuthServerProvider,
        private http: HttpClient,
        private cookieService: CookieService,
        private dataSharingService: DataSharingService,
        private translateService: TranslateService
    ) {
        this.loading = true;
        this.createForm();
    }

    ngOnInit() {
        this.route.data.subscribe(routeData => {
            this.isFirstLogin = routeData.isFirstLogin;

            this.jwtService
                .authorize(this.isFirstLogin)
                .toPromise()
                .then(res => {
                    this.getInitData();
                })
                .catch(err => {});
        });

        this.jwtService
            .organization()
            .toPromise()
            .then(res => {
                this.organization = res.body
                this.checkOrganization(this.organization);
            });

        const appUrl = this.cookieService.get('appUrl');
        if (appUrl) {
            this.jwtService.appUrl = appUrl;
        }

        this.subscriptions = [
            this.userForm.controls['alternativeEmail'].valueChanges.subscribe(value => {
                this.changeVerified();
            }, error => this.errorAlternativeEmail = error),
            this.userForm.controls['email'].valueChanges.subscribe(value => {
                this.changeVerified();
            }, error => this.errorEmail = error),
            this.userForm.controls['phone'].valueChanges.subscribe({
                next: (value) => {this.changeVerified()},
                error: (error) => {this.errorPhone = error}
            })
        ];
        this.prefixes = [
            1,
            1242,
            1246,
            1264,
            1268,
            1284,
            1340,
            1345,
            1441,
            1473,
            1649,
            1664,
            1670,
            1671,
            1684,
            1758,
            1767,
            1784,
            1787,
            1809,
            1868,
            1869,
            1876,
            20,
            212,
            213,
            216,
            218,
            220,
            221,
            222,
            223,
            224,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            235,
            236,
            237,
            238,
            239,
            240,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250,
            251,
            252,
            253,
            254,
            255,
            256,
            257,
            258,
            260,
            261,
            262,
            263,
            264,
            265,
            266,
            267,
            268,
            269,
            269,
            27,
            290,
            290,
            291,
            297,
            298,
            299,
            30,
            31,
            32,
            33,
            34,
            350,
            351,
            352,
            353,
            354,
            355,
            356,
            357,
            358,
            359,
            36,
            370,
            371,
            372,
            373,
            374,
            375,
            376,
            377,
            378,
            379,
            380,
            381,
            382,
            385,
            386,
            387,
            388,
            389,
            39,
            39,
            40,
            41,
            420,
            421,
            423,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            500,
            501,
            502,
            503,
            504,
            505,
            506,
            507,
            508,
            509,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            590,
            591,
            592,
            593,
            594,
            595,
            596,
            597,
            598,
            599,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            670,
            672,
            673,
            674,
            675,
            676,
            677,
            678,
            679,
            680,
            681,
            682,
            683,
            685,
            686,
            687,
            688,
            689,
            690,
            691,
            692,
            7,
            7,
            800,
            808,
            81,
            82,
            84,
            850,
            852,
            853,
            855,
            856,
            86,
            870,
            878,
            880,
            881,
            882,
            883,
            886,
            888,
            90,
            91,
            92,
            93,
            94,
            95,
            960,
            961,
            962,
            963,
            964,
            965,
            966,
            967,
            968,
            970,
            971,
            972,
            973,
            974,
            975,
            976,
            977,
            979,
            98,
            991,
            992,
            993,
            994,
            995,
            996,
            998
        ];

        const language = this.translateService.getBrowserLang();

        this.http
            .get(SERVER_API_URL + 'content/' + CURRENTPOLICYVERSION + '.' + language + '.html', { responseType: 'text' })
            .subscribe(d => {
                this.privacyPolicyHtml = d;
            });

        this.isMefMail = this.isMefEmail();
    }

    checkOrganization(organization: string) {
        if(organization.toLowerCase()==='dag'){
            this.orgDag=true;
        }
    }

    private createForm() {

        this.userForm = this.formBuilder.group({
            email: ['', [Validators.required]],
            alternativeEmail: [''],
            office: [''],
            prefixSelect: ['39'],
            phone: [''],
            question: ['', [Validators.required]],
            answer: ['', [Validators.required]],
            pin: [''],
            privacyCheckbox: ['']
        });
        /*
        if(this.orgDag){
            this.userForm = this.formBuilder.group({
                email: ['', [Validators.required]],
                alternativeEmail: [''],
                office: [''],
                prefixSelect: ['39'],
                phone: [''],
                question: ['', [Validators.required]],
                answer: ['', [Validators.required]],
                pin: [''],
                privacyCheckbox: ['']
            });

        }else{
            this.userForm = this.formBuilder.group({
                email: ['', [Validators.required]],
                alternativeEmail: [''],
                office: [''],
                prefixSelect: ['39'],
                phone: [''],
                question: ['', [Validators.required]],
                answer: ['', [Validators.required]],
                privacyCheckbox: ['']
            });
        }


         */
    }

    get f() {
        return this.userForm.controls;
    }

    get fEmail() {
        return this.userForm.get('email');
    }
    get fAltEmail() {
        return this.userForm.get('alternativeEmail');
    }
    get fOffice() {
        return this.userForm.get('office');
    }
    get fPrefix() {
        return this.userForm.get('prefixSelect');
    }
    get fPhone() {
        return this.userForm.get('phone');
    }

    get fQuestion() {
        return this.userForm.get('question');
    }
    get fAnswer() {
        return this.userForm.get('answer');
    }
    get fPin() {
        return this.userForm.get('pin');
    }
    get fPrivacyCheckbox() {
        return this.userForm.get('privacyCheckbox');
    }

    onSubmit(needOtp: boolean) {


        // stop here if form is invalid
        if (this.userForm.invalid) {
            return;
        }
        if (!this.userForm.controls['privacyCheckbox'].value) {
            return;
        }
        if (this.userForm.get('email').value === this.userForm.get('alternativeEmail').value) {
            return;
        }
        this.submitted = true;

        const phoneValue = this.phoneAcquisitionEnabled && this.fPhone.value ? '+' + this.fPrefix.value + this.fPhone.value : this.user?.phone ?? null;
        const phoneVerified = this.phoneAcquisitionEnabled ? this.verifiedPhone : true;

        const outObj:IUser = new UpdateUser(
            this.fEmail.value,
            this.fAltEmail.value,
            this.fOffice.value,
            phoneValue,
            this.fQuestion.value,
            this.fAnswer.value,
            this.isAnswerSetted,
            this.fPin.value,
            this.fPrivacyCheckbox ? CURRENTPOLICYVERSION : null,
            this.verifiedEmail,
            this.verifiedAltEmail,
            phoneVerified
        );

        /*
        let outObj: IUser;

        if(this.orgDag){
            outObj= new UpdateUser(
                this.fEmail.value,
                this.fAltEmail.value,
                this.fOffice.value,
                this.fPhone.value ? '+' + this.fPrefix.value + this.fPhone.value : null,
                this.fQuestion.value,
                this.fAnswer.value,
                this.isAnswerSetted,
                this.fPin.value,
                this.fPrivacyCheckbox ? CURRENTPOLICYVERSION : null,
                this.verifiedEmail,
                this.verifiedAltEmail,
                this.verifiedPhone
            );
        }else{
            outObj = new UpdateUser(
                this.fEmail.value,
                this.fAltEmail.value,
                this.fOffice.value,
                this.fPhone.value ? '+' + this.fPrefix.value + this.fPhone.value : null,
                this.fQuestion.value,
                this.fAnswer.value,
                this.isAnswerSetted,
                '',
                this.fPrivacyCheckbox ? CURRENTPOLICYVERSION : null,
                this.verifiedEmail,
                this.verifiedAltEmail,
                this.verifiedPhone
            );
        }

         */

        if (needOtp) {
            this.userService.setUserToVerify(outObj);

            this.userService
                .generateOTP(outObj)
                .toPromise()
                .then(res => {
                    this.userService.timeoutOTP = res.body.timeoutOTP;
                    if (this.isFirstLogin) {
                        this.router.navigate(['../primoAccessoVerificaOTP'], { relativeTo: this.route });
                    } else {
                        this.router.navigate(['../verificaOtp'], { relativeTo: this.route });
                    }
                })
                .catch(err => {
                    if (err && err.error) {
                        this.errorMsg = err.error.message;
                    }
                })
                .finally(() => {
                    // console.log('done');
                });
        } else {
            if (this.isFirstLogin) {
                // recupero i dati per cambio password
                const pwdToChange = this.userService.pwdtoChange;

                this.userService
                    .changePassword(pwdToChange)
                    .toPromise()
                    .then(() => {
                        outObj.delay = true;

                        this.userService
                            .updateUser(outObj)
                            .toPromise()
                            .then(res => {
                                if (res && res.body && res.body.message) {
                                    this.successMsg = res.body.message;
                                } else {
                                    this.successMsg = 'Operazione effettuata con successo';
                                }
                            })
                            .catch(err => {
                                this.verifyValidationError(err);
                            })
                            .finally(() => {
                                this.submitted = false;
                            });
                    })
                    .catch(err => {
                        this.verifyValidationError(err);
                        this.submitted = false;
                    });
            } else {
                this.userService
                    .updateUser(outObj)
                    .toPromise()
                    .then(res => {
                        if (res && res.body && res.body.message) {
                            this.successMsg = res.body.message;
                        } else {
                            this.successMsg = 'Operazione effettuata con successo';
                        }
                    })
                    .catch(err => {
                        this.verifyValidationError(err);
                    })
                    .finally(() => {
                        this.submitted = false;
                    });
            }
        }
    }

    verifyValidationError(err: HttpErrorResponse) {
        if (err && err.error) {
            if (err.error.message === 'error.validation') {
                this.errorMsg = 'Si è verificato un errore nella validazione dei campi.';
            } else {
                this.errorMsg = err.error.message;
            }
        }
    }

    onReset() {
        this.submitted = false;
        this.populateForm();
        this.userForm.markAsPristine();
    }

    private getInitData() {
        this.userService
            .getLogged()
            .toPromise()
            .then(res => {
                this.user = res.body;
                
                // Check if user can access the form based on userType
                // Only EXTRA_UE users can access when passwordless mode is enabled
                if (this.user.showPwdlessWarning) {
                    // User is not EXTRA_UE, show only warning
                    this.canAccessForm = false;
                    // Load warning message from backend (same as change-password)
                    this.loadWarningMessage();
                } else {
                    // User can access the form
                    this.canAccessForm = true;
                    this.populateForm();

                    if (this.isFirstLogin) {
                        this.userForm.markAsDirty();
                    }
                }
            })
            .catch(err => {
                // console.log(err);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private loadWarningMessage() {
        this.userService.getUserTypeWarning('passwordless').subscribe(
            (message: string) => {
                this.pwdlessWarningMessage = message;
            },
            error => {
                console.warn('Could not load passwordless warning message', error);
                this.pwdlessWarningMessage = this.translateService.instant('error.functionality.not.available');
            }
        );
    }

    private populateForm() {

        this.verifiedPhone = this.phoneAcquisitionEnabled ? this.user.phoneVerified : true;
        this.verifiedEmail = this.user.emailVerified;
        this.verifiedAltEmail = this.user.alternativeEmailVerified;
        this.isAnswerSetted = this.user.challengeAnswerSetted;
        this.privacyPolicyUpToDate = this.user.privacyPolicyAcceptedVersion === CURRENTPOLICYVERSION;

        let answerToDisplay = '******';
        if (this.user.challengeAnswerSetted === false) {
            answerToDisplay = '';
        }

        const phoneToPatch = this.phoneAcquisitionEnabled && this.user.phone ? this.user.phone : '';

        if(this.orgDag){
            this.userForm.patchValue({
                email: this.user.email,
                alternativeEmail: this.user.alternativeEmail ? this.user.alternativeEmail : '',
                office: this.user.office,
                phone: phoneToPatch,
                question: this.user.challengeQuestion,
                answer: answerToDisplay,
                pin: this.user.pin,
                privacyCheckbox: this.privacyPolicyUpToDate
            });
        }else{
            this.userForm.patchValue({
                email: this.user.email,
                alternativeEmail: this.user.alternativeEmail ? this.user.alternativeEmail : '',
                office: this.user.office,
                phone: phoneToPatch,
                question: this.user.challengeQuestion,
                answer: answerToDisplay,
                privacyCheckbox: this.privacyPolicyUpToDate
            });
        }

        this.changeConfirmEnabled();
    }

	//<!-- AGGIUNGERE CONDIZIONE DAG-RGS -->
    changeShowPin($event: any) {

        if(this.orgDag){
            this.showPin = !this.showPin;
        }

    }

    editAnswer($event: any) {
        this.isAnswerSetted = false;
        this.userForm.patchValue({
            answer: ''
        });
    }

    backToApp() {
        this.router.navigate(['/']);
    }

    changeVerified() {
        if (this.userForm.controls['email'].value === this.user.email) {
            this.verifiedEmail = this.user.emailVerified;
        } else {
            this.verifiedEmail = false;
        }
        if (this.userForm.controls['alternativeEmail'].value === this.user.alternativeEmail) {
            this.verifiedAltEmail = this.user.alternativeEmailVerified;
        } else {
            this.verifiedAltEmail = false;
        }
        if (this.phoneAcquisitionEnabled) {
            if (this.userForm.controls['phone'].value === this.user.phone) {
                this.verifiedPhone = this.user.phoneVerified;
            } else {
                this.verifiedPhone = false;
            }
        } else {
            this.verifiedPhone = true;
        }

        if (this.verifiedEmail === false || this.verifiedAltEmail === false || (this.phoneAcquisitionEnabled && this.verifiedPhone === false)) {
            this.userForm.markAsDirty();
        }

        this.changeConfirmEnabled();
    }

    changeConfirmEnabled() {
        if (
            !this.verifiedEmail ||
            (!this.verifiedAltEmail && this.isNotEmpty(this.userForm.controls['alternativeEmail'])) ||
            (!this.verifiedPhone && this.phoneValidationEnabled && this.isNotEmpty(this.userForm.controls['phone']))
        ) {
            this.enableConfirm = false;
        } else {
            this.enableConfirm = true;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    isNotEmpty(control: AbstractControl) {
        return control.value !== '';
    }

    get isMobile(): boolean {
        return this.dataSharingService.isMobile();
    }

    get isTablet(): boolean {
        return this.dataSharingService.isTablet();
    }

    get isDesktop(): boolean {
        return this.dataSharingService.isDesktop();
    }

    redirect() {
        if (this.isFirstLogin) {
            this.userService
                .logout()
                .toPromise()
                .then(r => {
                    // remove jwt token client-side
                    this.jwtService.logout();

                    const backUrl = this.cookieService.get('backUrl');
                    if (backUrl) {
                        window.location.href = backUrl;
                    } else {
                        this.router.navigate(['/']);
                    }
                })
                .catch(err => {});
        } else {
            this.router.navigate(['/']);
        }
    }

    redirectOnFailure() {
        if (this.isFirstLogin) {
            this.router.navigate(['/primoAccesso']);
        }
    }

    isMefEmail() {
        let result = false;
        /*this.userService
            .getLogged()
            .toPromise()
            .then(res => {
                this.user = res.body;
            });*/
        const check_email = '[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](mef.gov.it)';
        const patt = new RegExp(check_email);

        if (!!this.user && this.user.email) {
            result = patt.test(this.user.email);
        }
        return result;
    }
}
